var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/tip-msg-item.html');
/*require('./../../style/msg/tip-msg-item.less');*/
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var MsgStatus = require('./../../constant/MsgStatus');
var XssFilter = require('../../../lib/XssFilter');
var RichTextFormat = require('../../../lib/RichTextFormat');
var utils = require('./../../global/utils');
var isEmpty = utils.isEmpty;

var TipMsgItem = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        BaseMsgItem.call(self, defaults);
    })(this);

    // 是否已经被render过
    this._rendered = false;
    this._isConfirmed = false;
};
TipMsgItem.prototype = Object.create(BaseMsgItem.prototype);
TipMsgItem.prototype.renderContent = function () {
    var msg = this._data.msg;
    var originalContent = msg.content;
    var contentType = originalContent && originalContent.type;
    var content;
    var action = {};
    var a = this._element.find('.im-msg-tip-content');
    switch (contentType) {
        case 'tip':
        case 'modify_msg':
            content = originalContent.text;
            content = RichTextFormat.richTextFormat(msg).content.text;
            var sender_info = this._data.msg.sender_info;
            var replace_index = content.indexOf("撤回一条消息");
            if (replace_index !== -1 && content !== "你撤回一条消息") {
              if(sender_info && sender_info.user_source !==108 ){//群聊逻辑
                content = ((!isEmpty(sender_info) && !isEmpty(sender_info.nick_name)) ? sender_info.nick_name : sender_info.user_name ? sender_info.user_name : content.substring(0, replace_index)) + content.substring(replace_index);
              }
              
            }
            if(!isEmpty(msg.original_content) && (msg.original_content.type == 'text' || msg.original_content.type == 'modify_msg')){
              action = {
                name: 'redit',
                content: msg.original_content.msg || ''
              };
            }
            break;
        case 'operation_tip':
            content = originalContent.default_text;
            break;
        case 'auth_tip':
            content = originalContent.default_text;
            if (originalContent.action_text) {
                var posStart = originalContent.action_text.pos_start;
                var posEnd = originalContent.action_text.pos_end;
                content = content.substring(0, posStart - 1) + '<a style="cursor:pointer">' + content.substring(posStart - 1, posEnd) + '</a>' + content.substring(posEnd);
            }
            var self = this;
            a[0].addEventListener('click', function (e) {
                /*    var text = '请在APP中进行"群聊邀请确认"';
                   dispatcher.dispatch({
                       type: ActionType.TOAST_SHOW,
                       data: {
                           content: text,
                           interval: 2000
                       }
                   }); */
                if (self._isConfirmed) {
                    return;
                }
                var msg = self._data.msg;
                var targetGid = msg.to_id;
                var targetGSource = msg.to_source;
                if (targetGSource < 10000 && msg.sender_source > 10000) {
                    targetGid = msg.sender_id;
                    targetGSource = msg.sender_source;
                }
                var inviteId = msg.content.invite_id;
                var tipMsgId = msg.msg_id;
                dispatcher.dispatch({
                    type: ActionType.CONFIRM_INVITE,
                    data: {
                        target_gid: targetGid,              //(必传参数)，要修改的群的id
                        target_gsource: targetGSource,        //必传参数，群source
                        invite_id: inviteId, //必传参数，邀请ID
                        tip_msg_id: tipMsgId //(必传参数)，邀请的tip消息id
                    }
                });
                var originalContent = msg.content;
                var content = originalContent.default_text;
                if (originalContent.action_text) {
                    var posStart = originalContent.action_text.pos_start;
                    var posEnd = originalContent.action_text.pos_end;
                    content = content.substring(0, posStart - 1) + '已确认' + content.substring(posEnd);
                    self._element.find('.im-msg-tip-content').html(content);
                    self._isConfirmed = true;
                }
            })
            break;
        default:
            break;
    }

    // xssFilter,将'<script'替换成’&lt;script将'script>'替换成script&gt;
    content = XssFilter.doFilter(content);
    this._element.find('.im-msg-tip-content').html(content);
    if(action.name == 'redit' && msg.is_mine)this._element.find('.im-msg-redit-content').html('重新编辑').data('redit-content', action.content);

};

module.exports = TipMsgItem;
